import { Button, Tooltip } from "@mantine/core";
import { Plus } from "lucide-react";

export interface SaveButtonProps {
  /** "Add Brand", "Add Product": the button on a new item; a saved one says "Save". */
  addLabel: string;
  editing: boolean;
  /** Live's required fields are filled and no upload is running. */
  ready: boolean;
  /** Why it waits, on a new item, as live's tooltip says it. */
  required: string;
  pending: boolean;
  size?: "sm" | "md";
}

/**
 * A form's save, as live's (design-system.md 3.6): grey until live's required fields are filled,
 * with a tooltip naming them on a new item. It stays focusable and hoverable for that tooltip
 * (`data-disabled`, not `disabled`), so the form also refuses a submit while it is not ready.
 */
export function SaveButton(props: SaveButtonProps) {
  const { addLabel, editing, ready, required, pending, size = "sm" } = props;
  return (
    <Tooltip
      label={required}
      multiline
      withArrow
      position="top"
      w={280}
      disabled={editing || ready}
    >
      <Button
        type="submit"
        size={size}
        loading={pending}
        data-disabled={!ready}
        aria-disabled={!ready}
        onClick={(event) => {
          if (!ready) event.preventDefault();
        }}
        {...(editing ? {} : { leftSection: <Plus size={size === "md" ? 16 : 20} strokeWidth={1.5} /> })}
      >
        {editing ? "Save" : addLabel}
      </Button>
    </Tooltip>
  );
}
